import { render, staticRenderFns } from "./batchApplicationSubmit.vue?vue&type=template&id=4892d62f&scoped=true"
import script from "./batchApplicationSubmit.vue?vue&type=script&lang=js"
export * from "./batchApplicationSubmit.vue?vue&type=script&lang=js"
import style0 from "./batchApplicationSubmit.vue?vue&type=style&index=0&id=4892d62f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4892d62f",
  null
  
)

export default component.exports